import {
  apiClient,
  ApiClientConfig,
} from 'api';

import { listDataType } from '../components/type';
import { EventsResponse } from 'features/cms';

export const DashboardApiService = () => {

  const getEvents = async (Flag: string) => {
    const response = await apiClient({
      endpoint: `admin/dropdownlist?${Flag}`
    })

    return response.data
  }

  const getDashboardGraphData = async (eventId: number, categoryId: number, Flag: string) => {

    const response = await apiClient<listDataType>({
      endpoint: `admin/dashboard?EventId=${eventId}&SportsCategoryId=${categoryId}&Flag=${Flag}`

    })

    return response.data
  }


  const getDashboardData = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardgraphdata`,
      params,
    });

    return response.data;
  };

  const getDashBoardExecutiveSummary = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/agentdashboard/executivesummarygraph`,
      params,
    });

    return response.data;
  };
  const getDashBoardCard = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/agentdashboard/getdashboardtopdata`,
      params,
    });

    return response.data;
  };
  const getDashBoardDropDown = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/agentdashboard/commondropdowndashboardlist`,
      params,
    });

    return response.data;
  };
  const getDashBoardTraget = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/registrationeventbaseddata`,
      params,
    });
    
return response.data;
  };
  const getDashBoardTragetPiecircle = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/registrationeventbaseddata`,
      params,
    });
    // admin/dashboard/getregistrationcirclegraphdata

    return response.data;
  };
  const getDashBoardregistrationdemographic = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/getdashboardregistrationdemographicdata`,
      params,
    });

    return response.data;
  };
  const getDashboardcrosssalessummary = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/getdashboardregistrationcrosssalessummary`,
      params,
    });

    return response.data;
  };
  const getDashboardregistrationcrosssales = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/registrationeventbaseddata`,
      params,
    });
    
return response.data;
  };

  const getDashboardshopSales = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/getdashboardshopsummary`,
      params,
    });

    return response.data;
  };

   const getDashboardshopCategory = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/getdashboardshopgraphs`,
      params,
    });

    return response.data;
  };
  const getDashboardBooth = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentdashboard/getdashboardboothdata`,
      params,
    });

    return response.data;
  };
  
return {
    getEvents,
    getDashboardGraphData,
    getDashboardData,
    getDashBoardExecutiveSummary,
    getDashBoardCard,
    getDashBoardDropDown,
    getDashBoardTraget,
    getDashBoardTragetPiecircle,
    getDashBoardregistrationdemographic,
    getDashboardcrosssalessummary,
    getDashboardregistrationcrosssales,
    getDashboardshopSales,
    getDashboardshopCategory,
    getDashboardBooth
  };
};



